import { createSlice } from '@reduxjs/toolkit'
import { ACTIVE } from 'components/customer-details/content/location/list/settings'

const getInitialState = () => ({
  selectedTab: ACTIVE,
  expandedRowIds: [],
  sortModel: [],
  filters: {
    filterModel: { items: [], quickFilterExcludeHiddenColumns: false },
  },
  selectedLocationForMenu: null,
  locationAnchorEl: null,
  moreActionsAnchorEl: null,
  showDeactivateAllConfirmation: false,
  isOpenAddLocationDialog: false,
})

const customerDetailsLocationsSlice = createSlice({
  name: 'customerDetailsLocations',
  initialState: getInitialState(),
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload
      state.expandedRowIds = []
    },
    setExpandedRowIds: (state, action) => {
      state.expandedRowIds = action.payload
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      }
    },
    resetFilters: state => {
      state.filters = {
        filterModel: { items: [], quickFilterExcludeHiddenColumns: false },
      }
    },
    setSelectedLocationForMenu: (state, action) => {
      state.selectedLocationForMenu = action.payload
    },
    setLocationAnchorEl: (state, action) => {
      state.locationAnchorEl = action.payload
    },
    setMoreActionsAnchorEl: (state, action) => {
      state.moreActionsAnchorEl = action.payload
    },
    setShowDeactivateAllConfirmation: (state, action) => {
      state.showDeactivateAllConfirmation = action.payload
    },
    setIsOpenAddLocationDialog: (state, action) => {
      state.isOpenAddLocationDialog = action.payload
    },
    resetState: () => getInitialState(),
  },
})

export const {
  setSelectedTab,
  setExpandedRowIds,
  setSortModel,
  setFilters,
  setSelectedLocationForMenu,
  setLocationAnchorEl,
  setMoreActionsAnchorEl,
  setShowDeactivateAllConfirmation,
  setIsOpenAddLocationDialog,
  resetState,
  resetFilters,
} = customerDetailsLocationsSlice.actions

export default customerDetailsLocationsSlice.reducer
